import { Lesson, LessonKey } from "../types/lessonTypes";
import { getDatabaseItem } from "../../../services/database/getDatabaseItem";

export async function getLesson(userId: string, id: string) {

    const lesson = await getDatabaseItem<Lesson, LessonKey>("/lessons", { userId, id })

    return lesson
}